import { render, staticRenderFns } from "./app-detail-download-pc.vue?vue&type=template&id=1fb630aa&scoped=true&"
import script from "./app-detail-download-pc.vue?vue&type=script&lang=js&"
export * from "./app-detail-download-pc.vue?vue&type=script&lang=js&"
import style0 from "./app-detail-download-pc.vue?vue&type=style&index=0&id=1fb630aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb630aa",
  null
  
)

export default component.exports